import React, { FC, Suspense } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import routes, { AppRoute } from 'routes';
import RouteWrapper from 'routes/routeWrapper';
import LoadingPage from 'pages/loading';

const App: FC = () => (
  <Suspense fallback={<LoadingPage />}>
    <Switch>
      {routes.map((route: AppRoute, index: number) => {
        const { path, component: Component, layout: Layout, ...rest } = route;
        
        return (
          <RouteWrapper
            key={`app-route-${index}-${path}`}
            path={path}
            component={Component}
            layout={Layout}
            {...rest}
          />
        );
      })}
      <Redirect to="/" />
    </Switch>
</Suspense>
);

export default App;